export default function Footer() {
  const nav = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })

  return (
    <>
      <footer style={{
        background: 'var(--bone)',
        borderTop: '1px solid rgba(0,0,0,0.08)',
        padding: 'clamp(40px,6vw,64px) clamp(24px,5vw,56px)',
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: 40, alignItems: 'start',
      }}>
        <style>{`
          @media (max-width:640px) { #footer-grid { grid-template-columns: 1fr !important; } }
          .footer-link:hover { color: var(--pitch) !important; }
        `}</style>

        <div id="footer-grid" style={{ display: 'contents' }}>
          <div>
            <div style={{ fontFamily: 'var(--f-d)', fontSize: 22, letterSpacing: '0.16em', marginBottom: 6 }}>
              A. Thomson
            </div>
            <div style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'rgba(0,0,0,0.25)' }}>
              Private Aerial Tuition · Manchester
            </div>
          </div>

          <div>
            <div style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'rgba(0,0,0,0.25)', marginBottom: 16 }}>
              Navigation
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[['sessions','Sessions'],['passes','Class passes']].map(([id, label]) => (
                <span key={label} className="footer-link"
                  onClick={() => nav(id)}
                  style={{ fontSize: 13, fontWeight: 300, color: 'rgba(0,0,0,0.5)', cursor: 'pointer', transition: 'color 0.15s' }}>
                  {label}
                </span>
              ))}
              <a href="/testimonials" className="footer-link"
                style={{ fontSize: 13, fontWeight: 300, color: 'rgba(0,0,0,0.5)', textDecoration: 'none', transition: 'color 0.15s' }}
                onMouseEnter={e => e.target.style.color = 'var(--pitch)'}
                onMouseLeave={e => e.target.style.color = 'rgba(0,0,0,0.5)'}>
                Testimonials
              </a>
            </div>
          </div>

          <div>
            <div style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'rgba(0,0,0,0.25)', marginBottom: 16 }}>
              Legal
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <a href="/terms" style={{ fontSize: 13, fontWeight: 300, color: 'rgba(0,0,0,0.5)', textDecoration: 'none', transition: 'color 0.15s' }}
                onMouseEnter={e => e.target.style.color = 'var(--pitch)'}
                onMouseLeave={e => e.target.style.color = 'rgba(0,0,0,0.5)'}>
                Terms &amp; Conditions
              </a>
              <a href="/my-account" style={{ fontSize: 13, fontWeight: 300, color: 'rgba(0,0,0,0.5)', textDecoration: 'none', transition: 'color 0.15s' }}
                onMouseEnter={e => e.target.style.color = 'var(--pitch)'}
                onMouseLeave={e => e.target.style.color = 'rgba(0,0,0,0.5)'}>
                My account
              </a>
            </div>
          </div>

          <div>
            <div style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'rgba(0,0,0,0.25)', marginBottom: 16 }}>
              Contact
            </div>
            <div style={{ fontSize: 13, fontWeight: 300, color: 'rgba(0,0,0,0.5)', lineHeight: 1.9 }}>
              <a href="mailto:audrey@athomson.uk" style={{ color: 'var(--pitch)', textDecoration: 'none', borderBottom: '1px solid rgba(0,0,0,0.15)' }}>
                audrey@athomson.uk
              </a>
              <br /><br />Cloud Aerial Arts<br />Manchester
            </div>
          </div>
        </div>
      </footer>

      <div style={{
        padding: '20px clamp(24px,5vw,56px)',
        borderTop: '1px solid rgba(0,0,0,0.06)',
        display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8,
        background: 'var(--bone)',
      }}>
        {['© 2025 A. Thomson', 'Private Aerial Tuition · Manchester'].map(t => (
          <span key={t} style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'rgba(0,0,0,0.2)' }}>
            {t}
          </span>
        ))}
      </div>
    </>
  )
}
